// This Factory is for Dynamic Component processing -- it is stored outside of the dc component for dependency management
export enum InterfaceFactory {
  Background = "BackgroundInterface",
  BackgroundVideo = "BackgroundVideoInterface",
  Button = "ButtonInterface",
  Custom = "CustomElementInterface",
  Heading = "HeadingInterface",
  Text = "TextInterface",
  LegalWrapper = "LegalWrapper",
  LegalWrapperInterface = "LegalWrapper",
  Legal = "LegalWrapperInterface",
  Link = "LinksInterface",
  Panels = "PanelsInterface",
  IconSvg = "IconSvgInterface",
  Image = "ImageInterface",
  BasicPricing = "BasicPricingInterface",
  Timer = "TimerInterface",
  CheckAvailabilityPanel = "CheckAvailabilityPanelInterface",
}
